(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-simple-drawer"] = factory();
	else
		root["vue-simple-drawer"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 